var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',[_c('dashboard-content'),_c('content-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }